import { render, staticRenderFns } from "./list.vue?vue&type=template&id=e3437c5e&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=e3437c5e&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=e3437c5e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3437c5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3437c5e')) {
      api.createRecord('e3437c5e', component.options)
    } else {
      api.reload('e3437c5e', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=e3437c5e&scoped=true", function () {
      api.rerender('e3437c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/list.vue"
export default component.exports